import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import StatusLabel from "@saleor/components/StatusLabel";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { SaleProductDetails_sale_products_edges } from "@saleor/discounts/types/SaleProductDetails";
import {
  SaleVariantDetails_sale_productVariants_edges,
  SaleVariantDetails_sale_productVariants_edges_node
} from "@saleor/discounts/types/SaleVariantDetails";
import { ProductStatusEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
import { ListActions, ListProps } from "../../../types";
import { SaleDetails_sale } from "../../types/SaleDetails";
import { VoucherDetails_voucher } from "../../types/VoucherDetails";
export interface SaleProductsProps extends ListProps, ListActions {
  discount: SaleDetails_sale | VoucherDetails_voucher;
  products: SaleProductDetails_sale_products_edges[];
  variants: SaleVariantDetails_sale_productVariants_edges[];
  discountView?: string;
  onProductAssign: () => void;
  onProductUnassign: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonDisabled: {
      "& > span": {
        color: "#616161"
      }
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 230
    },
    colNameLabel: {
      // marginLeft: theme.spacing()
    },
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 150
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "DiscountProducts" }
);

const numberOfVariantColumns = 10;
// const numberOfPercentageColumns = 5;

const DiscountProducts: React.FC<SaleProductsProps> = props => {
  const {
    discount: sale,
    disabled,
    discountView,
    pageInfo,
    onRowClick,
    onPreviousPage,
    onProductAssign,
    onProductUnassign,
    onNextPage,
    isChecked,
    selected,
    toggle,
    toggleAll,
    toolbar,
    variants
    // products
  } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  // function showPercentageTable() {
  //   return (
  //     <ResponsiveTable className={classes.table}>
  //       <colgroup>
  //         <col />
  //         <col className={classes.colName} />
  //         <col className={classes.colType} />
  //         <col className={classes.colPublished} />
  //         {products && products.length > 0 && (
  //           <col className={classes.colActions} />
  //         )}
  //       </colgroup>
  //       <TableHead
  //         colSpan={5}
  //         selected={selected}
  //         disabled={disabled}
  //         items={maybe(() => products.map(edge => edge.node))}
  //         toggleAll={toggleAll}
  //         toolbar={toolbar}
  //       >
  //         <TableCell className={classes.colName}>
  //           <span className={classes.colNameLabel}>
  //             <FormattedMessage defaultMessage="Product Name" />
  //           </span>
  //         </TableCell>
  //         <TableCell className={classes.colType}>
  //           <FormattedMessage defaultMessage="Product Type" />
  //         </TableCell>
  //         <TableCell className={classes.colPublished}>
  //           <FormattedMessage
  //             defaultMessage="{name}"
  //             description="product is published"
  //             values={{
  //               name: discountView === "sales" ? "Product Status" : "Published"
  //             }}
  //           />
  //         </TableCell>
  //         {/* <TableCell className={classes.colPrice}>
  //           <FormattedMessage defaultMessage="Retail Price" />
  //         </TableCell>
  //         <TableCell className={classes.colPrice}>
  //           <FormattedMessage defaultMessage="Selling Price" />
  //         </TableCell> */}
  //         {products && products.length === 0 ? (
  //           <TableCell className={classes.colEmpty} />
  //         ) : (
  //           <TableCell className={classes.colActions} />
  //         )}

  //         {products && products.length === 0 && (
  //           <TableCell className={classes.colEmpty} />
  //         )}
  //       </TableHead>
  //       <TableFooter>
  //         <TableRow>
  //           <TablePagination
  //             colSpan={numberOfPercentageColumns}
  //             hasNextPage={pageInfo ? pageInfo.hasNextPage : false}
  //             onNextPage={onNextPage}
  //             hasPreviousPage={pageInfo ? pageInfo.hasPreviousPage : false}
  //             onPreviousPage={onPreviousPage}
  //           />
  //         </TableRow>
  //       </TableFooter>
  //       <TableBody>
  //         {renderCollection(
  //           maybe(() => products.map(edge => edge.node)),
  //           product => {
  //             const isSelected = product ? isChecked(product.id) : false;
  //             return (
  //               <TableRow
  //                 hover={!!product}
  //                 key={product ? product.id : "skeleton"}
  //                 onClick={product && onRowClick(product.id)}
  //                 className={classes.tableRow}
  //                 selected={isSelected}
  //               >
  //                 <TableCell padding="checkbox">
  //                   <Checkbox
  //                     checked={isSelected}
  //                     disabled={disabled}
  //                     disableClickPropagation
  //                     onChange={() => toggle(product.id)}
  //                   />
  //                 </TableCell>
  //                 <TableCell className={classes.colName}>
  //                   {maybe(() => product.name)}
  //                 </TableCell>
  //                 {/* <TableCellAvatar
  //                   className={classes.colName}
  //                   thumbnail={isImportImage(maybe(() => product.thumbnail.url))}
  //                 >
  //                   {maybe<React.ReactNode>(() => product.name, <Skeleton />)}
  //                 </TableCellAvatar> */}
  //                 <TableCell className={classes.colType}>
  //                   {maybe<React.ReactNode>(
  //                     () => product.productType.name,
  //                     <Skeleton />
  //                   )}
  //                 </TableCell>
  //                 <>
  //                   <TableCell className={classes.colPublished}>
  //                     {product && product.productStatus !== undefined ? (
  //                       <StatusLabel
  //                         label={intl.formatMessage(
  //                           {
  //                             defaultMessage: "{values}",
  //                             description: "product status"
  //                           },
  //                           {
  //                             values: product.productStatus
  //                           }
  //                         )}
  //                         status={
  //                           product.productStatus === ProductStatusEnum.READY
  //                             ? "success"
  //                             : "error"
  //                         }
  //                       />
  //                     ) : (
  //                       <Skeleton />
  //                     )}
  //                   </TableCell>
  //                 </>
  //                 <TableCell className={classes.colActions}>
  //                   <IconButton
  //                     disabled={!product || disabled}
  //                     onClick={event => {
  //                       event.stopPropagation();
  //                       onProductUnassign(product.id);
  //                     }}
  //                   >
  //                     <DeleteIcon color="primary" />
  //                   </IconButton>
  //                 </TableCell>
  //               </TableRow>
  //             );
  //           },
  //           () => (
  //             <TableRow>
  //               <TableCell colSpan={5}>
  //                 <FormattedMessage defaultMessage="No products found" />
  //               </TableCell>
  //             </TableRow>
  //           )
  //         )}
  //       </TableBody>
  //     </ResponsiveTable>
  //   );
  // }

  function showVariantsTable() {
    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col />
          <col className={classes.colSKU} />
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colPublished} />
          <col className={classes.colPrice} />
          <col className={classes.colPrice} />
          <col className={classes.colPrice} />
          <col className={classes.colPrice} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfVariantColumns}
          selected={selected}
          disabled={disabled}
          items={maybe(() => variants.map(edge => edge.node))}
          toggleAll={toggleAll}
          toolbar={toolbar}
        >
          {variants && variants.length === 0 && <TableCell />}
          {discountView === "sales" && (
            <TableCell className={classes.colSKU}>
              <FormattedMessage defaultMessage="SKU" />
            </TableCell>
          )}
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Product Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Classification" />
          </TableCell>
          <TableCell className={classes.colPublished}>
            <FormattedMessage
              defaultMessage="{name}"
              description="product is published"
              values={{
                name: discountView === "sales" ? "Product Status" : "Published"
              }}
            />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Retail Price" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Selling Price" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Tenant Discount" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="SMO Discount" />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={numberOfVariantColumns}
              hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
              onNextPage={onNextPage}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : false
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {renderCollection(
            maybe(() => variants.map(edge => edge.node)),
            (variant, index) => {
              const isSelected = variant ? isChecked(variant.id) : false;
              return (
                <TableRow
                  hover={!!variant}
                  key={variant ? variant.id : "skeleton"}
                  onClick={variant && onRowClick(variant.product.id)}
                  className={classes.tableRow}
                  selected={isSelected}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      id={`checkboxRow${index}`}
                      checked={isSelected}
                      disabled={disabled}
                      disableClickPropagation
                      onChange={() => toggle(variant.id)}
                    />
                  </TableCell>
                  {discountView === "sales" && (
                    <TableCell className={classes.colSKU} id={`skuRow${index}`}>
                      {maybe<React.ReactNode>(() => variant.sku, <Skeleton />)}
                    </TableCell>
                  )}
                  <TableCell
                    className={classes.colName}
                    id={`productNameRow${index}`}
                  >
                    {productName(variant)}
                  </TableCell>
                  {/* <TableCellAvatar
                    className={classes.colName}
                    thumbnail={isImportImage(maybe(() => product.thumbnail.url))}
                  >
                    {maybe<React.ReactNode>(() => product.name, <Skeleton />)}
                  </TableCellAvatar> */}
                  <TableCell
                    className={classes.colType}
                    id={`classificationRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => variant.product.productType.name,
                      <Skeleton />
                    )}
                  </TableCell>
                  {discountView === "sales" ? (
                    <>
                      <TableCell
                        className={classes.colPublished}
                        id={`productStatusRow${index}`}
                      >
                        {variant &&
                        variant.product.productStatus !== undefined ? (
                          <StatusLabel
                            label={intl.formatMessage(
                              {
                                defaultMessage: "{values}",
                                description: "product status"
                              },
                              {
                                values: variant.product.productStatus
                              }
                            )}
                            status={
                              variant.product.productStatus ===
                              ProductStatusEnum.READY
                                ? "success"
                                : "error"
                            }
                          />
                        ) : (
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.colPrice}
                        id={`retailPriceRow${index}`}
                      >
                        {maybe<React.ReactNode>(
                          () => variant.price.amount,
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.colPrice}
                        id={`sellingPriceRow${index}`}
                      >
                        {maybe<React.ReactNode>(
                          () => variant.sellingPrice.amount,
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.colPrice}
                        id={`tenantDiscountRow${index}`}
                      >
                        {maybe<React.ReactNode>(
                          () => parseFloat(`${variant.tenantShare}`).toFixed(2),
                          <Skeleton />
                        )}
                      </TableCell>
                      <TableCell
                        className={classes.colPrice}
                        id={`smoDiscountRow${index}`}
                      >
                        {maybe<React.ReactNode>(
                          () => parseFloat(`${variant.smoShare}`).toFixed(2),
                          <Skeleton />
                        )}
                      </TableCell>
                    </>
                  ) : (
                    <TableCell
                      className={classes.colPublished}
                      id={`publishRow${index}`}
                    >
                      {variant && variant.product.isPublished !== undefined ? (
                        <StatusLabel
                          label={
                            variant.product.isPublished
                              ? intl.formatMessage({
                                  defaultMessage: "Published",
                                  description: "product is published"
                                })
                              : intl.formatMessage({
                                  defaultMessage: "Not published",
                                  description: "product is not published"
                                })
                          }
                          status={
                            variant.product.isPublished ? "success" : "error"
                          }
                        />
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                  )}

                  <TableCell className={classes.colActions}>
                    <IconButton
                      id={`deleteIconRow${index}`}
                      disabled={!variant || disabled}
                      onClick={event => {
                        event.stopPropagation();
                        onProductUnassign(variant.id);
                      }}
                    >
                      <DeleteIcon color="primary" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            },
            () => (
              <TableRow>
                <TableCell colSpan={numberOfVariantColumns}>
                  <FormattedMessage
                    defaultMessage="No products found"
                    id="noProductsFound"
                  />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  function productName(
    variant: SaleVariantDetails_sale_productVariants_edges_node
  ) {
    if (variant && variant.product) {
      if (variant.product.isSimpleProduct) {
        return variant.product.name;
      }
      return `${variant.product.name} - ${variant.name}`;
    }
    return "";
  }

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Eligible Products",
          description: "section header"
        })}
        toolbar={
          sale ? (
            <Button
              id="assignProductsBtn"
              disabled={disabled}
              color="primary"
              className={disabled ? classes.buttonDisabled : null}
              onClick={onProductAssign}
            >
              <FormattedMessage
                defaultMessage="Assign products"
                description="button"
              />
            </Button>
          ) : (
            ""
          )
        }
      />
      {sale &&
        (sale.type === "ABSOLUTE_VALUE" || sale.type === "PERCENTAGE") &&
        showVariantsTable()}
      {/* {sale && discountView === "sales" && sale.type === "ABSOLUTE_VALUE"
        ? showVariantsTable()
        : showPercentageTable()} */}
    </Card>
  );
};
DiscountProducts.displayName = "DiscountProducts";
export default DiscountProducts;
